export const hiddenCityCodes = ["DLT", "MKT", "MNS", "MSP", "STC"]

export default { hiddenCityCodes }
